import type { AxiosError } from 'axios'

import type { ErrorHandlerPort, ErrorHandlerResult } from '../ports/ErrorHandlerPort'

/**
 * Handles HTTP 409 Conflict errors
 * These are typically resolved by returning the response instead of rejecting
 */
export class ConflictErrorHandler implements ErrorHandlerPort {
  canHandle(error: AxiosError): boolean {
    return error.response?.status === 409
  }

  async handleError(): Promise<ErrorHandlerResult> {
    return {
      handled: true,
      shouldShowToast: false,
      shouldReject: false // Don't reject, resolve with the response
      // No custom action needed - the shouldReject: false handles the resolution
    }
  }
}
